const elements = [
  {
    id: "1",
    title: "Reporta siniestros",
    text: "Desde nuestra app o desde el portal web, reporta cualquier siniestro que tengas.",
  },
  {
    id: "2",
    title: "Reporta siniestros 2",
    text: "Desde nuestra app o desde el portal web, reporta cualquier siniestro que tengas.",
  },
  {
    id: "3",
    title: "Reporta siniestros 3",
    text: "Desde nuestra app o desde el portal web, reporta cualquier siniestro que tengas.",
  },
  {
    id: "4",
    title: "Reporta siniestros 4",
    text: "Desde nuestra app o desde el portal web, reporta cualquier siniestro que tengas.",
  },
  {
    id: "5",
    title: "Reporta siniestros 5",
    text: "Desde nuestra app o desde el portal web, reporta cualquier siniestro que tengas.",
  },
  {
    id: "6",
    title: "Reporta siniestros 6",
    text: "Desde nuestra app o desde el portal web, reporta cualquier siniestro que tengas.",
  },
];

export default elements;
